module.exports = __webpack_public_path__ + "img/Animales-KX5600.8f86620a.png";